export const PROFESSOR_REPORT_HEADERS_KEYS = [
    {
      headerName: "First Name",
      keyName: "first_name",
      typeof: "string",
    },
    {
      headerName: "Last Name",
      keyName: "last_name",
      typeof: "string",
    },
    { headerName: "User Name", keyName: "username", typeof: "string" },
    {
      headerName: "Email Address",
      keyName: "email_address",
      typeof: "string",
    },
    {
      headerName: "Mobile Number",
      keyName: "mobile_number",
      typeof: "string",
    },
    {
      headerName: "LoggedIn At",
      keyName: "user_login_log",
      typeof: "array",
      value: "login_at"
    },
    {
      headerName: "Roles",
      keyName: "userByRole",
      typeof: "array",
      value: "role",
    },
    {
      headerName: "Status",
      keyName: "is_active",
      typeof: "boolean",
      value: ["Active", "InActive"],
    },
  ];
  